export default __webpack_public_path__ + "static/media/bg.ba869747.png";